function copyToClipboard(value: string) {
  if (typeof navigator !== "undefined") {
    try {
      navigator.clipboard.writeText(value);
      return;
    } catch (err) {
      /** ignore this error */
    }
  }
}

export default {
  copyToClipboard,
};
